export const COPY_UPDATE_PASSWORD_TITLE = "Update Password";
export const COPY_UPDATE_PASSWORD_SUCCESS_TITLE = "Password updated!";
